<div class="card">
  <div class="sejam-info">
    <div class="name">
      <img
        src="wealth-assets/svg/user.svg"
        alt="{{ user?.firstName }}"
      />
      <p class="user-name">{{ user?.firstName }} {{ user?.lastName }}</p>
    </div>

    <ngx-badge
      size="md"
      status="info"
      mode="fill"
      [hasIcon]="true"
      type="text"
    >
      {{ getUserSejamInfo() }}
    </ngx-badge>
  </div>

  <div class="national-id">
    <p class="title">کد ملی:</p>
    <p class="value">{{ user?.nationalId }}</p>
  </div>

  <div class="phone-number">
    <p class="title">شماره موبایل:</p>
    <p class="value">{{ user?.phoneNumber }}</p>
  </div>
</div>
